var sw = require('js/lib/sw');
var swUtils = require('js/lib/sw-utils');
var $ = require('js/sw-jquery/sw-jquery');
var modelShareIntentTrack = require('js/lib/tracking/model-share-intent');
var _gaq = require('js/lib/tracking/google-analytics');

/**
 * Returns the normalized tracker name configuration parameter.
 * @param {string} opt_trackerName An optional name for the tracker object.
 * @return {string} If opt_trackerName is set, then the value appended with
 *     a . Otherwise an empty string.
 * @private
 */
function buildTrackerName_(opt_trackerName) {
  return opt_trackerName ? opt_trackerName + '.' : '';
}

/**
 * Tracks everytime a user clicks on a tweet button from Twitter.
 * This subscribes to the Twitter JS API event mechanism to listen for
 * clicks coming from this page. Details here:
 * http://dev.twitter.com/pages/intents-events#click
 * This method should be called once the twitter API has loaded.
 * @param {string} opt_pageUrl An optional URL to associate the social
 *     tracking with a particular page.
 * @param {string} opt_trackerName An optional name for the tracker object.
 */
function trackTwitter(opt_pageUrl, opt_trackerName) {
  var trackerName = buildTrackerName_(opt_trackerName);
  var twttr = window.twttr;
  try {
    if (twttr && twttr.events && twttr.events.bind) {
      twttr.events.bind('tweet', function (event) {
        if (event) {
          var targetUrl; // Default value is undefined.
          if (event.target && event.target.nodeName === 'IFRAME') {
            targetUrl = swUtils.extractParamFromUri(event.target.src, 'url');
          }
          _gaq.push([trackerName + '_trackSocial', 'twitter', 'tweet',
            targetUrl, opt_pageUrl]);
        }
      });
    }
  } catch (e) {
  }
}

/**
 * Tracks Facebook likes, unlikes and sends by suscribing to the Facebook
 * JSAPI event model. Note: This will not track facebook buttons using the
 * iFrame method.
 * @param {string} opt_pageUrl An optional URL to associate the social
 *     tracking with a particular page.
 * @param {string} opt_trackerName An optional name for the tracker object.
 */
function trackFacebook(opt_pageUrl, opt_trackerName) {
  var FB = window.FB;
  if (typeof FB !== 'undefined') {
    var trackerName = buildTrackerName_(opt_trackerName);
    try {
      if (FB && FB.Event && FB.Event.subscribe) {
        FB.Event.subscribe('edge.create', function (targetUrl) {
          _gaq.push([trackerName + '_trackSocial', 'facebook', 'like',
            targetUrl, opt_pageUrl]);
        });
        FB.Event.subscribe('edge.remove', function (targetUrl) {
          _gaq.push([trackerName + '_trackSocial', 'facebook', 'unlike',
            targetUrl, opt_pageUrl]);
        });
        FB.Event.subscribe('message.send', function (targetUrl) {
          _gaq.push([trackerName + '_trackSocial', 'facebook', 'send',
            targetUrl, opt_pageUrl]);
        });

        /* Comment tracking from the tucknott.net blog */

        FB.Event.subscribe('comment.create', function (targetUrl) {
          _gaq.push(['_trackSocial', 'facebook', 'comment', targetUrl]);
        });

        FB.Event.subscribe('comment.remove', function (targetUrl) {
          _gaq.push(['_trackSocial', 'facebook', 'uncomment', targetUrl]);
        });

      }
    } catch (e) {
    }
  }
}

/* Facebook functions */
window.fbAsyncInit = function fbAsyncInit() {
  var FB = window.FB;
  FB.init({
    appId: sw.data.facebookAppId,
    status:true, // check login status
    cookie:true, // enable cookies to allow the server to access the session
    xfbml:true, // parse XFBML
    oauth:true,
    version:"v2.8"
  });

  var $modelId;
  if (FB.Event && FB.Event.subscribe) {

    $modelId = false;
    // auth.prompt should only occur on a like button.. hopefully this won't change!
    FB.Event.subscribe('auth.prompt', function (targetUrl) {
      var $parsePairs = targetUrl.split("?");
      var $modelValuePair;
      if ($parsePairs.length > 1) {
        $modelValuePair = $parsePairs[1].split("=");
        if ($modelValuePair.length > 1) {
          $modelId = $modelValuePair[1];
        }
      }
      if ($modelId) {
        modelShareIntentTrack(sw.data.eventTracking.modelShareIntentLoggedOut, $modelId, 'facebook');
      }
    });
    FB.Event.subscribe('edge.create', function (targetUrl) {
      var $parsePairs = targetUrl.split("?");
      var $modelValuePair;
      if ($parsePairs.length > 1) {
        $modelValuePair = $parsePairs[1].split("=");
        if ($modelValuePair.length > 1) {
          $modelId = $modelValuePair[1];
        }
      }
      if ($modelId) {
        modelShareIntentTrack(sw.data.eventTracking.modelShareIntentComplete, $modelId, 'facebook');
      }
    });

    FB.Event.subscribe('auth.authResponseChange', function(response) {
      if ($("#fblogout").length > 0 && FB.getAccessToken()) {
        $("#fblogout").remove();
        FB.logout();
      }
      if (response.status === 'connected') {
        //do here the log
      } else if (response.status === 'not_authorized') {
        FB.logout();
      }
    });

  }

  trackFacebook();
};

/* Twitter functions */
var twitterLoaded = false;
$.swPortal.loadTwitter = function () {

  if (twitterLoaded) {
    return;
  }

  window.twttr = (function (d, s, id) {
    var t, js, fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) { return; }
    js = d.createElement(s);
    js.id = id;
    js.src = "//platform.twitter.com/widgets.js";
    fjs.parentNode.insertBefore(js, fjs);
    return window.twttr || (t = { _e:[], ready:function (f) {
        t._e.push(f);
      } });
  }(document, "script", "twitter-wjs"));

  window.twttr.ready(function (twttr) {
    trackTwitter();
    var $modelId;
    if ($('a.twitter-share-button').length) {

      twttr.events.bind('click', function (event) {
        $modelId = null;
        if ($modelId && event && event.region === 'tweet') {
          modelShareIntentTrack(sw.data.eventTracking.modelShareIntent, $modelId, 'twitter');
        }
      });
      twttr.events.bind('tweet', function (event) {
        $modelId = null;
        if ($modelId && event) {
          modelShareIntentTrack(sw.data.eventTracking.modelShareIntentComplete, $modelId, 'twitter');
        }
      });
    }
  });

  twitterLoaded = true;
};

$(function () {
  // (function (d, s, id) {
  //   var js, fjs = d.getElementsByTagName(s)[0];
  //   if (d.getElementById(id)) { return; }
  //   js = d.createElement(s);
  //   js.id = id;
  //   js.src = "//connect.facebook.net/en_US/sdk.js";
  //   fjs.parentNode.insertBefore(js, fjs);
  // }(document, 'script', 'facebook-jssdk'));

  (function () {
    var po = document.createElement('script');
    po.type = 'text/javascript';
    po.async = true;
    po.src = 'https://accounts.google.com/gsi/client';
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(po, s);
  })();
});



